import { render, staticRenderFns } from "./ngos-data-view.vue?vue&type=template&id=ee4f6048&"
import script from "./ngos-data-view.vue?vue&type=script&lang=js&"
export * from "./ngos-data-view.vue?vue&type=script&lang=js&"
import style0 from "./ngos-data-view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports